import { render, staticRenderFns } from "./Type11a.vue?vue&type=template&id=724a1b23&"
import script from "./Type11a.vue?vue&type=script&lang=js&"
export * from "./Type11a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports